import React from 'react';
import { acAlert, acAlertCircleOutline, acCheckCircleOutline } from 'ac-icon';
import { COLORS } from '../../colors';
import Icon from '../../icon/Icon';
import classNames from 'classnames';
const Alert = ({ className, message, color, iconPath, iconColor, iconPosition, iconSize, iconTitle, onClick, href, target, }) => {
    const css = classNames('ac-alert', { 'cursor-pointer': onClick }, color, className);
    const getDefaultIcon = () => {
        switch (color) {
            case 'danger':
                return acAlertCircleOutline;
            case 'success':
                return acCheckCircleOutline;
            case 'warning':
                return acAlert;
        }
    };
    const getDefaultIconColor = () => {
        switch (color) {
            case 'danger':
                return COLORS.red;
            case 'success':
                return COLORS.teal600;
            case 'warning':
                return COLORS.gray600;
        }
    };
    const cssChildren = classNames('d-flex w-100', `align-items-${iconPosition || 'center'}`, css);
    const children = (React.createElement("div", { className: `d-flex align-items-${iconPosition || 'center'} w-100 ` + cssChildren },
        React.createElement(Icon, { path: iconPath !== null && iconPath !== void 0 ? iconPath : getDefaultIcon(), color: iconColor !== null && iconColor !== void 0 ? iconColor : getDefaultIconColor(), size: iconSize !== null && iconSize !== void 0 ? iconSize : '16px', title: iconTitle, className: 'alert-icon' }),
        message));
    if (href) {
        return (React.createElement("a", { href: href, target: target, className: 'ac-alert-link d-flex align-items-start w-100', onClick: onClick }, children));
    }
    else {
        return (React.createElement("div", { className: 'd-flex align-items-start w-100', onClick: onClick }, children));
    }
};
export { Alert };
//# sourceMappingURL=Alert.js.map